import React from 'react';
import Skeleton from '@wconcept/wconcept-ui-renewal/components/atoms/Skeleton';

import * as S from './style';

/** 코너 가로 리스트 한 칸 (썸네일 + 텍스트 3줄) */
const CornerItem = () => (
  <li className="item">
    <Skeleton className="thum" />
    <Skeleton className="text01" />
    <Skeleton className="text02" />
    <Skeleton className="text03" />
  </li>
);

/**
 * 카테고리 서브(/publ/category/sub) 스켈레톤.
 * 탭 메뉴바는 로딩 중에도 실제로 노출하므로 그 아래부터 그린다.
 * 추천 상품 1줄. (메인과 달리 배너·퀵메뉴가 없다)
 * LP 는 API 가 달라 응답 시점에 맞춰 따로 걷히도록 CategoryLpSkeleton 으로 분리했다.
 */
const CategorySubSkeleton = () => (
  <S.Box className="category-sub-skeleton">
    <Skeleton className="cont-title" />

    {/* 추천 상품 : 가로 스크롤 1줄 */}
    <div className="box-prd">
      <ul className="list">
        <CornerItem />
        <CornerItem />
        <CornerItem />
        <CornerItem />
      </ul>
    </div>
  </S.Box>
);

export default CategorySubSkeleton;
